module.exports = __webpack_public_path__ + "img/img-upload.3c8a26fa.png";